import React, { useEffect, useState } from "react";
import styled from "styled-components";

type CollapsibleType = {open: boolean};

const Container = styled.div`
    font-size: 1.11rem;
`;

const Header = styled.p`
    align-items: center;
    border-bottom: 1px solid var(--text-primary);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 0 0 1em;
    padding: 0.75em 0;

    & > span {
        display: block;
        flex-grow: 1;
        padding-right: 1em;
        white-space: nowrap;
    }
`;

const Title = styled.h2`
    body.theme-market & {
        font-family: var(--ff-subtitle);
        font-size: ${(16/12.6).toFixed(2)}rem !important;
        font-weight: 900;
        margin-bottom: 0.5em !important;
        text-transform: uppercase !important;
    }
`;

const Name = styled.span`
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;

    body.theme-platinum & { font-weight: 400; }
    body.theme-market & {
        font-family: var(--ff-subtitle);
        font-size: ${(12/12.6).toFixed(2)}rem;
        text-transform: uppercase;
    }
`;

const Summary = styled.p`
    margin: 1em 0;

    body.theme-market & {
        font-size: ${(12/12.6).toFixed(2)}rem;
    }
`;

const Arrow = styled.i`
    font-size: 1em;
    margin-top: 0.25em;
`;

const Content = styled.div<CollapsibleType>`
    display: ${props => props.open ? 'block' : 'none'};
    margin-bottom: 2.5rem;
`;

interface Props {
    bigTitle?: boolean,
    children: React.ReactNode,
    mandatory?: boolean,
    name: string,
    summary: string,
}

function CandybarConfigPanel(props:Props) {
    const [open, setOpen] = useState(false);
    const title = getTitle(props);
    const ref = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open || !ref.current) {
            return;
        }

        const container = ref.current.closest('.floating-window') as HTMLDivElement;
        if (container) {
            const yOffset = -80;
            const y = ref.current.offsetTop + yOffset;
            container.scrollTo({ top: y, behavior: 'smooth' });
        }
    }, [open]);

    return <Container className="candybar-config-panel">
        <div ref={ref}>
            <Header onClick={() => setOpen(!open)}>
                {props.bigTitle
                    ? <Title className="title-2 catalog-block-title mb-0">
                        {title}
                    </Title>
                    : <Name>
                        {title}
                    </Name>}
                <Arrow className={`fa-light fa-angle-${open ? 'up' : 'down'}`}></Arrow>
            </Header>
        </div>
        {!open && props.summary && props.summary.length > 0 && <Summary>{props.summary}</Summary>}
        <Content open={open}>
            {props.children}
        </Content>
    </Container>;
}

function getTitle(props:Props) {
    return <React.Fragment>
        {props.name}
        {' '}
        {true === props.mandatory && <span className="primary">(obligatorio)</span>}
        {false === props.mandatory && <span className="accent">(opcional)</span>}
    </React.Fragment>;
}

export default CandybarConfigPanel;